import {
  FETCH_USERS,
  OPEN_CHAT,
  FETCH_CHAT_THREAD,
  FETCH_CHATS,
  VIEW_USER_MODAL,
  ATTENDEE_LIST_MODAL,
  TIMEOUT_LIST,
  MEETING_MODAL,
  SHOW_BACK_SCREEN,
  FETCH_SUGGESTED_USERS,
  OPEN_SUGGESTED_FILTER
} from '../actions';

export const userData = (state = {}, action) => {
  switch (action.type) {
    case FETCH_USERS:
      return action.payload;
    default:
      return state;
  }
};

export function openChatReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_CHAT:
      return action.payload;
    default:
      return state;
  }
}

export function chatThreadData(state = {}, action) {
  switch (action.type) {
    case FETCH_CHAT_THREAD:
      return action.payload;
    default:
      return state;
  }
}

export function chatData(state = {}, action) {
  switch (action.type) {
    case FETCH_CHATS:
      return action.payload;
    default:
      return state;
  }
}

export function viewUserReducer(state = {}, action) {
  switch (action.type) {
    case VIEW_USER_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function attendeeListModalReducer(state = {}, action) {
  switch (action.type) {
    case ATTENDEE_LIST_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function timeoutListReducer(state = false, action) {
  switch (action.type) {
    case TIMEOUT_LIST:
      return action.payload;
    default:
      return state;
  }
}

export function meetingModalReducer(state = {}, action) {
  switch (action.type) {
    case MEETING_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function showBackScreenChat(state = {}, action) {
  switch (action.type) {
    case SHOW_BACK_SCREEN:
      return action.payload;
    default:
      return state;
  }
}

export const suggestedUserDataReducer = (state = {}, action) => {
  if (action.type == FETCH_SUGGESTED_USERS) {
    return action.payload;
  }
  return state;
};

export const openSuggestedFilterListReducer = (state = {}, action) => {
  if (action.type == OPEN_SUGGESTED_FILTER) return action.payload;
  return state;
};
